import { Injectable } from '@angular/core';
import { AppPartnerService, AppSettings } from '@galaxy/marketplace-apps';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppConfigService } from '../core/app-config.service';

const DEFAULT_CV_ICON = 'https://vstatic-prod.apigateway.co/customer-voice-client.9223372035066326780.prod/assets/images/cv-logo.png';

@Injectable()
export class WhiteLabelService {
  constructor(
    private readonly appPartnerService: AppPartnerService,
    private readonly appConfigService: AppConfigService,
    private readonly translateService: TranslateService,
  ) {}

  public getAppIconUrl$(): Observable<string> {
    return this.appConfigService.appConfig.pipe(
      switchMap((config) =>
        this.appPartnerService.getAppSettings(config.vendorCenterAppId, config.partnerId, config.marketId).pipe(
          catchError(() => of(null)),
          map((appSettings: AppSettings) =>
            appSettings?.branding?.iconUrl && appSettings?.branding?.enabled
              ? appSettings.branding.iconUrl
              : DEFAULT_CV_ICON,
          ),
        ),
      ),
    );
  }

  public getAppName$(): Observable<string> {
    return this.appConfigService.appConfig.pipe(
      switchMap((config) =>
        this.appPartnerService.getAppSettings(config.vendorCenterAppId, config.partnerId, config.marketId).pipe(
          catchError(() => of(null)),
          map((appSettings: AppSettings) =>
            appSettings?.branding?.name && appSettings?.branding?.enabled
              ? appSettings.branding.name
              : this.translateService.instant('APP_NAME'),
          ),
        ),
      ),
    );
  }
}
